import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { privilegesObject } from 'src/app/services/privileges-object';

@Component({
  selector: 'app-privileges-generate',
  templateUrl: './privileges-generate.component.html',
  styleUrls: ['./privileges-generate.component.css']
})
export class PrivilegesGenerateComponent implements OnInit {


  privilegesData: any = privilegesObject

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    console.log('privilegesObject: ', this.privilegesData)
  }

  singlePrivilege: any = [];

  viewPrivilege(privilege: any) {
    this.singlePrivilege = [privilege];
  }

  editPrivilege(privilege: any) {
    this.singlePrivilege = [privilege];
  }

  addSubMenu(index: number) {
    let newSubMenu = {
      description: "",
      name: "",
      seqNo: 0,
      add: true,
      view: true,
      modify: true,
      delete: true,
      verify: true,
      approve: true,
      issue: true,
      attach: true,
      remove: true,
      screenPrivilegeScopeList: []
    };
    if (this.singlePrivilege[0].screenPrivilegeList) {
      this.singlePrivilege[0].screenPrivilegeList.splice(index + 1, 0, newSubMenu);
    } else {
      this.singlePrivilege[0].screenPrivilegeList = [newSubMenu];
    }
  }

  removeSubMenu(index: number) {
    if (this.singlePrivilege[0].screenPrivilegeList) {
      this.singlePrivilege[0].screenPrivilegeList.splice(index, 1);
    }
  }


  addPrivilege() {

    for (let privilege of this.privilegesData) {

      let body = {
        "version": 0,
        "isActive": true,
        "description": privilege.description,
        "seqNo": privilege.seqNo,
        "groupName": privilege.groupName,
        "screenPrivilegeList": privilege.screenPrivilegeList,
        "cid": sessionStorage.getItem('cid') || 0
      }

      privilege.isSubmitted = false;
      privilege.isError = false;

      this.generic_service.addPrivileges(body).subscribe(
        (response: any) => {
          console.log(response.response)
          privilege.isSubmitted = true;
        },
        (error: any) => {
          console.log(error)
          privilege.isError = true;
        }
      )
    }


  }



}
